function set_blank() {
  document.querySelectorAll('a').forEach(function(link) {
    if (link.host && link.host !== window.location.host) {
      link.target = "_blank";
    }
  });
}

document.addEventListener("turbo:load", () => {
  set_blank();
});
